import { ReplicaType } from "types";
import Version1 from "./v1";
import Version2 from "./v2";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "daily-prophet-hp4-terror-at-the-quidditch-world-cup",
  name: `The Daily Prophet\n'Terror at the Quidditch World Cup'`,
  nameFormatted: {
    primary: "The Daily Prophet",
    secondary: "'Terror at the Quidditch World Cup'",
  },
  origin: "Harry Potter and the Goblet of Fire",

  category: replicaCategories.harryPotter,

  versions: [Version2, Version1],
};

export default data;
